import { getParametrizedUrl } from '@x_x_x/utils';

import { URLS_API } from '@constants';

import { BaseApi, IRequestOptions } from '../BaseApi';

import {
	IApiBodyDimensionsLogCreateRequestParams,
	IApiBodyDimensionsLogCreateRequestBody,
	IApiBodyDimensionsLogCreateResponseData,

	IApiBodyDimensionsLogUpdateRequestParams,
	IApiBodyDimensionsLogUpdateRequestBody,
	IApiBodyDimensionsLogUpdateResponseData,
} from './types';

export class BodyDimensionsLogApi extends BaseApi {

	async create(options: IRequestOptions<IApiBodyDimensionsLogCreateRequestParams, IApiBodyDimensionsLogCreateRequestBody>) {
		const { body } = options;

		return this.post<IApiBodyDimensionsLogCreateRequestBody, IApiBodyDimensionsLogCreateResponseData>({
			url: getParametrizedUrl(URLS_API.BODY_DIMENSIONS_LOG),
			data: body,
		});
	}

	async update(options: IRequestOptions<IApiBodyDimensionsLogUpdateRequestParams, IApiBodyDimensionsLogUpdateRequestBody>) {
		const { params, body } = options;

		return this.put<IApiBodyDimensionsLogUpdateRequestBody, IApiBodyDimensionsLogUpdateResponseData>({
			url: getParametrizedUrl(URLS_API.BODY_DIMENSIONS_LOG_ITEM, params as unknown as Record<string, string>),
			data: body,
		});
	}

}
